type PropertyAmenitySuggestionInput = {
  amenities?: string[] | string
  areaSqm?: number | string
  bathrooms?: number | string
  bedrooms?: number | string
  furnished?: boolean
  listingType?: string
  maxGuests?: number | string
  propertyType?: string
}

function toNumber(value: number | string | undefined) {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : 0
}

export function normalizeAmenityList(value: string[] | string | undefined) {
  if (Array.isArray(value)) {
    return value.map((item) => String(item || "").trim()).filter(Boolean)
  }

  return String(value || "")
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean)
}

export function suggestPropertyAmenities({
  amenities,
  areaSqm,
  bathrooms,
  bedrooms,
  furnished,
  listingType,
  maxGuests,
  propertyType,
}: PropertyAmenitySuggestionInput) {
  const existing = normalizeAmenityList(amenities)
  const next = new Set(existing.map((item) => item.toLowerCase()))
  const suggestions: string[] = []

  const add = (label: string) => {
    const normalized = label.toLowerCase()
    if (next.has(normalized)) return
    next.add(normalized)
    suggestions.push(label)
  }

  add("Climatisation")
  add("Wi-Fi")
  add("Cuisine equipee")

  if (furnished) {
    add("Mobilier complet")
    add("Salon meuble")
  } else {
    add("Placards de rangement")
  }

  if (String(listingType || "").toUpperCase() !== "SALE") {
    add("Pret a habiter")
  }

  switch (String(propertyType || "").toUpperCase()) {
    case "APPARTEMENT":
      add("Balcon")
      add("Ascenseur")
      add("Securite residence")
      break
    case "RESIDENCE_MEUBLEE":
      add("Television")
      add("Linge de maison")
      add("Menage possible")
      break
    case "VILLA":
      add("Jardin")
      add("Cour privee")
      add("Terrasse")
      break
    case "STUDIO":
      add("Kitchenette")
      add("Rangements integres")
      break
    case "IMMEUBLE":
      add("Parking visiteurs")
      add("Groupe electrogene")
      add("Securite 24/7")
      break
    default:
      add("Parking")
      add("Eau chaude")
      break
  }

  if (toNumber(bedrooms) >= 3) {
    add("Placards dans les chambres")
  }

  if (toNumber(bathrooms) >= 2) {
    add("Douche moderne")
  }

  if (toNumber(maxGuests) >= 4) {
    add("Espace repas")
  }

  if (toNumber(areaSqm) >= 80) {
    add("Grand sejour")
  }

  return suggestions.slice(0, 10)
}
